import React from 'react';
import { HOW_IT_WORKS_STEPS } from '../data/mock';
import { Search, ListChecks, Handshake } from 'lucide-react';

const iconMap = {
  Search: Search,
  ListChecks: ListChecks,
  Handshake: Handshake,
};

export const HowItWorks = () => {
  return (
    <section id="how-it-works" className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            How It Works
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Get started in three simple steps
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 md:gap-12">
          {HOW_IT_WORKS_STEPS.map((step, index) => {
            const Icon = iconMap[step.icon];
            return (
              <div key={step.step} className="relative text-center">
                {/* Connector line */}
                {index < HOW_IT_WORKS_STEPS.length - 1 && (
                  <div className="hidden md:block absolute top-12 left-[60%] w-[80%] h-0.5 bg-gradient-to-r from-cyo-orange/30 to-cyo-orange/10" />
                )}

                {/* Step number */}
                <div className="relative inline-flex items-center justify-center mb-6">
                  <div className="w-24 h-24 bg-white rounded-2xl shadow-lg flex items-center justify-center border border-gray-100">
                    <Icon className="w-10 h-10 text-cyo-orange" />
                  </div>
                  <div className="absolute -top-2 -right-2 w-8 h-8 bg-cyo-orange text-white rounded-full flex items-center justify-center font-bold text-sm shadow-md">
                    {step.step}
                  </div>
                </div>

                {/* Title */}
                <h3 className="text-xl font-semibold text-gray-900 mb-3">
                  {step.title}
                </h3>

                {/* Description */}
                <p className="text-gray-500 max-w-xs mx-auto">
                  {step.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
